import { API } from "@/lib/api";

export const mediaUrl = (id) => `${API}/media/${id}`;

// Direct-playable src for <video>; null for YouTube/Vimeo embeds.
export const videoFileSrc = (v) => (v?.kind === "file" ? (v.media_id ? mediaUrl(v.media_id) : v.url) : null);

export const fmtBytes = (n) => (n >= 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.round(n / 1024)} KB`);
